import Variant from "../Models/Variant";
import MakeRequest from "../Utilities/MakeRequest";

export function getAllVariants(serviceId: string): Promise<Array<Variant>> {
	return new Promise<Array<Variant>>((resolve, reject) => {
		new MakeRequest(`/api/variants/getall?serviceId=${serviceId}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response))
			}, reject);
	});
}

export function fetchVariantsList(serviceId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/variants/Index?serviceId=${serviceId}`)
			.send()
			.then(resolve, reject);
	});
}

export function fetchCreateVariantModal(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest('/DomainAdmin/Variants/Create')
			.send()
			.then(resolve, reject);
	});
}

export function createVariant(serviceId: string, variantFormData: FormData): Promise<number> {
	return new Promise<number>((resolve, reject) => {
		new MakeRequest(`/api/Variants/Create?serviceId=${serviceId}`, "Post")
			.send(variantFormData)
			.then(resolve, reject);
	});
}

export function fetchUpdateVariantModal(serviceId: string, variantId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Variants/update?serviceId=${serviceId}&id=${variantId}`)
			.send()
			.then(resolve, reject);
	});
}

export function updateVariant(serviceId: string, variantFormData: FormData): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/variants/Update?serviceId=${serviceId}`, "Put")
			.send(variantFormData)
			.then(resolve, reject);
	});
}

export function updateVariantDisplayOrder(serviceId: string, variants: Array<Variant>): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/variants/UpdateDisplayOrder?serviceId=${serviceId}`, "Put", headers)
			.send(JSON.stringify(variants))
			.then(resolve, reject);
	});
}

export function fetchDeleteVariantModal(serviceId: string, variantId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Variants/delete?serviceId=${serviceId}&id=${variantId}`)
			.send()
			.then(resolve, reject);
	});
}

export function deleteVariant(itemCategoryId: string, serviceId: string, variantId: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/Variants/Delete?itemCategoryId=${itemCategoryId}&serviceId=${serviceId}&id=${variantId}`, "delete", headers)
			.send()
			.then(resolve, reject);
	});
}
